<template>
  <div class="App">
      <div id="maps">

      </div>
    <div>
      <strong class="font-weight-bold">Legenda:</strong><br>
      <img src="http://maps.google.com/mapfiles/ms/icons/blue-dot.png" alt=""> Inicio
      <img src="http://maps.google.com/mapfiles/ms/icons/green-dot.png" alt=""> Fim
      <img src="http://maps.google.com/mapfiles/ms/icons/red-dot.png" alt=""> Infração
      <img src="http://maps.google.com/mapfiles/ms/icons/yellow-dot.png" alt=""> Parada com mais de 10 minutos
    </div>
  </div>
</template>

<script>
import GoogleMapController from './GoogleMapController';

export default {
  name: 'App',
  props: {
    positions: {
      type: Array,
      required: true
    },
    beginTime: {
      required: true
    },
    infractions: {
      type: Array,
      requires: true
    }
  },
  async mounted() {
    await GoogleMapController.getMapPicture(600, 600, this.positions, this.beginTime, this.infractions);
  }
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
}

#maps {
  width: 100% !important;
}
</style>